(function () {
    const YT_REGEX =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|live\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/

    function parseYouTube(url) {
        try {
            const u = new URL(url)
            // Handle youtu.be/<id>
            if (u.hostname.includes('youtu.be')) {
                return { id: u.pathname.slice(1), start: getStartTime(u) }
            }
            // Handle youtube.com/watch?v=, /shorts/<id>, /live/<id>
            if (u.hostname.includes('youtube.com')) {
                if (u.pathname === '/watch') {
                    const id = u.searchParams.get('v')
                    return id ? { id, start: getStartTime(u) } : null
                }
                const parts = u.pathname.split('/').filter(Boolean)
                if (parts[0] === 'shorts' || parts[0] === 'live') {
                    return parts[1] ? { id: parts[1], start: getStartTime(u) } : null
                }
            }
            return null
        } catch {
            return null
        }
    }

    function getStartTime(u) {
        // supports ?t=1m30s or ?t=90 or &start=90
        const t = u.searchParams.get('t') || u.searchParams.get('start')
        if (!t) return 0
        if (/^\d+$/.test(t)) return parseInt(t, 10)
        // parse 1h2m3s
        const h = /(\d+)h/.exec(t)?.[1] ?? 0
        const m = /(\d+)m/.exec(t)?.[1] ?? 0
        const s = /(\d+)s/.exec(t)?.[1] ?? 0
        return (+h) * 3600 + (+m) * 60 + (+s)
    }

    function embedHtml(videoId, start = 0) {
        const qs = new URLSearchParams({
            rel: '0',
            modestbranding: '1',
            start: String(start || 0),
        }).toString()

        return (
            `<iframe src="https://www.youtube.com/embed/${videoId}?${qs}" ` +
            'title="YouTube video" frameborder="0" allow="accelerometer; autoplay; ' +
            'clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ' +
            'allowfullscreen class="mce-embed__responsive"></iframe>'
        )
    }

    function replaceBlockIfUrl(editor, text) {
        const parsed = parseYouTube(text.trim())
        if (!parsed) return false

        editor.undoManager.transact(() => {
            // Replace the whole current block with the embed
            const block = editor.selection.getStart()
            const parentBlock = editor.dom.getParent(block, editor.dom.isBlock)
            const html = embedHtml(parsed.id, parsed.start)
            if (parentBlock) {
                editor.selection.select(parentBlock)
                editor.selection.setContent(html)
            } else {
                editor.insertContent(html)
            }
        })
        return true
    }

    function replaceSelectionIfUrl(editor, text) {
        const parsed = parseYouTube(text.trim())
        if (!parsed) return false
        editor.undoManager.transact(() => {
            editor.selection.setContent(embedHtml(parsed.id, parsed.start))
        })
        return true
    }

    window.tinymce.PluginManager.add('youtube_autoembed', function (editor) {
        // Paste handler: if the paste is just a URL, convert
        editor.on('Paste', (e) => {
            const text = (e.clipboardData || e.originalEvent?.clipboardData)?.getData('text')
            if (!text) return

            const onlyUrl = text.trim()
            const isSingleLine = !/\n/.test(onlyUrl)
            if (isSingleLine && parseYouTube(onlyUrl)) {
                e.preventDefault()
                // If selection is collapsed and in empty block, replace the block
                const rng = editor.selection.getRng()
                const containerText = editor.selection.getNode().textContent || ''
                if (!containerText.trim()) {
                    replaceBlockIfUrl(editor, onlyUrl)
                } else {
                    replaceSelectionIfUrl(editor, onlyUrl)
                }
            }
        })

        // Type-to-embed: on space/enter, if the current block is a URL, convert
        editor.on('keydown', (e) => {
            if (e.key !== ' ' && e.key !== 'Enter') return

            const block = editor.selection.getStart()
            const parentBlock = editor.dom.getParent(block, editor.dom.isBlock)
            if (!parentBlock) return

            // Ignore if inside a link/code/pre
            if (editor.dom.getParent(block, 'a, code, pre')) return

            const text = parentBlock.innerText || parentBlock.textContent || ''
            if (YT_REGEX.test(text.trim())) {
                // Let space/enter finish, then transform
                setTimeout(() => replaceBlockIfUrl(editor, text), 0)
            }
        })

        // Toolbar button to convert selected text or current block manually
        editor.ui.registry.addButton('youtubeAutoEmbed', {
            icon: 'embed',
            tooltip: 'Embed YouTube from URL',
            onAction: () => {
                const selText = editor.selection.getContent({ format: 'text' }).trim()
                if (selText && replaceSelectionIfUrl(editor, selText)) return

                const block = editor.selection.getStart()
                const parentBlock = editor.dom.getParent(block, editor.dom.isBlock)
                const text = parentBlock ? (parentBlock.innerText || '').trim() : ''
                if (text) replaceBlockIfUrl(editor, text)
            },
        })

        return {
            getMetadata: () => ({
                name: 'YouTube Auto-Embed',
            }),
        }
    })
})()
